export default "__VITE_ASSET__DWHXyJOK__"